import axios from 'axios';
import { getAuthHeaders } from './userController';

// URL base de la API para sucursales
const BASE_URL = 'https://yokomo.api.ikeytechnologies.com/sucursales/';

// Obtener todas las sucursales
export const fetchSucursales = async () => {
  try {
    const response = await axios.get(BASE_URL,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener las sucursales:', error);
    throw error;
  }
};

// Obtener una sucursal específica
export const fetchSucursal = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}${id}/`,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener la sucursal:', error);
    throw error;
  }
};

// Crear una nueva sucursal
export const createSucursal = async (sucursalData) => {
  try {
    const response = await axios.post(BASE_URL, sucursalData,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al crear la sucursal:', error);
    throw error;
  }
};

// Actualizar una sucursal
export const updateSucursal = async (id, sucursalData) => {
  try {
    const response = await axios.put(`${BASE_URL}${id}/`, sucursalData,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al actualizar la sucursal:', error);
    throw error;
  }
};

// Eliminar una sucursal
export const deleteSucursal = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}${id}/`,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al eliminar la sucursal:', error);
    throw error;
  }
};
